<div class="flex flex-row justify-center items-center">
    <particle-file-selector
            [(file)]="fileToUpload"
            class="flex flex-column flex-1-1-50 md-100"
            [legend]="'Document (.pdf)'"
            [required]="true"
            [acceptedTypes]="'.pdf'"
            [showDriveOption]="!hasKPMGFeature"
            (change)="handleFileInput()"
    >
    </particle-file-selector>
</div>
<div *ngIf="!isCheckFileFormat" style="color: red;" class="flex flex-row">
    <label>Invalid File Type(Accepted Format: .pdf).</label><span>*</span>
</div>
<div class="m-t-15">
    <mat-checkbox [(ngModel)]="isFileScanned" data-copilot="convert-currency-checkbox-scanned">Treat as scanned</mat-checkbox>
</div>
<div class="m-t-10" *ngIf="isFileScanned">
    <mat-form-field appearance="outline" class="w-p-100" style="margin-bottom: 0!important;">
        <mat-label>Select a Language</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage" data-copilot="convert-currency-select-language">
            <mat-option
                    *ngFor="let language of taxformsSupportiveLanguage"
                    [value]="language.code"
                    [attr.data-copilot]="'convert-currency-option-' + language.code"
            >
                {{ language.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div class="m-t-15">
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
        <mat-label>Storage *</mat-label>
        <input matInput placeholder="Input" style="display: none"
               particleAnalytics
               analyticsCategory="choice-filter-modal-item-editor"
               analyticsAction="entity-scope-input">
        <mat-radio-group [(ngModel)]="storageSettings">
            <mat-radio-button [disabled]="hasKPMGFeature" [value]="storageOptions.Stored" class="m-b-12" data-copilot="convert-currency-radio-stored">
                <div class="flex flex-col">
          <span>
            I want to store this document in Orbitax
          </span>
                    <div class="hint flex flex-col">
                        <div class="flex flex-row">
                            Your document will be available to view, manage and share
                            with your contacts via the Translation tool at any point.
                        </div>
                    </div>
                </div>
            </mat-radio-button>
            <mat-radio-button [value]="storageOptions.NonStored" class="m-b-12" data-copilot="convert-currency-radio-non-stored">
                <div class="flex flex-col">
          <span>
            I do not want to store this document in Orbitax
          </span>
                    <div class="hint flex flex-col">

                        <div *ngIf="hasKPMGFeature" class="flex flex-row">
                            Your document will be available to download for 15 minutes
                            before being removed permanently from the system.
                        </div>

                        <div *ngIf="!hasKPMGFeature" class="flex flex-row">
                            Your document will be available to download for 24 hours
                            before being removed permanently from the system.
                        </div>
                    </div>
                </div>
            </mat-radio-button>
        </mat-radio-group>
    </mat-form-field>
</div>
